<script lang="ts">
  import { addThemeClass } from "../../../core";
  import type { IPanelData } from "../../../core/types";
  import Accordion from "./Accordion.svelte";

  interface IFaqPanel extends IPanelData {
    items: IFaqPanelItem[];
  }

  interface IFaqPanelItem {
    anchor: string;
    answer: string;
    question: string;
  }

  export let data: IFaqPanel;

  let anchorFromUrl = window.location.hash.replace("#", "");

  function checkHash(node: HTMLElement) {
    if (node.id && node.id === anchorFromUrl) {
      scrollToElement(node, 700);
    }
  }

  function scrollToElement(node: HTMLElement, delay: number) {
    setTimeout(() => {
      node.scrollIntoView({ block: "start", behavior: "smooth" });
    }, delay);
  }
</script>

<section class="faq-panel" use:addThemeClass={data}>
  <div class="content g-centered">
    <div class="items">
      {#each data.items as item}
        <div class="item" id={item.anchor} use:checkHash>
          <Accordion
            isShow={anchorFromUrl ? item.anchor === anchorFromUrl : false}
          >
            <h3 class="item-title" slot="title">{item.question}</h3>
            <div class="item-content rte" slot="content">
              {@html item.answer}
            </div>
          </Accordion>
        </div>
      {/each}
    </div>
  </div>
</section>

<style lang="scss">
  .faq-panel:not(.default-theme) {
    .item {
      :global(.accordion-button),
      :global(.answer) {
        padding-left: 20px;
        padding-right: 20px;
      }
    }
  }

  .content {
    margin-bottom: 50px;
  }

  .items {
    background: var(--background-color);
    border-top: 1px solid var(--faq-separator);
  }

  .item {
    :global(.accordion) {
      border-bottom: 1px solid var(--faq-separator);
    }

    :global(.arrow-icon) {
      border-color: var(--faq-arrow);
    }
  }

  .item-title {
    @include normal;
    font-weight: 900;
    padding: 8px 0 5px;
    color: var(--key-color);

    @include sm {
      padding: 16px 0 10px;
    }
  }
  .item-content {
    @include normal;
    padding-bottom: 10px;
    color: var(--text-color);
  }
</style>
